(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-audi"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });
  /**
  * Shop By Car Mega Menu — 3-Panel Interaction
  * Handles brand → model → generation selection
  */
  (function () {
    'use strict';

    function initShopByCarMega() {
      const sbcm = document.getElementById('shop-by-car-mega');
      if (!sbcm) return;

      // ── Brand selection ──────────────────────────────────────────
      const brandItems = sbcm.querySelectorAll('[data-sbcm-brand]');
      const modelGroups = sbcm.querySelectorAll('[data-brand-models]');

      brandItems.forEach(function (brandItem) {
        brandItem.addEventListener('mouseenter', function () {
          selectBrand(this.dataset.brand);
        });
        brandItem.addEventListener('click', function () {
          selectBrand(this.dataset.brand);
        });
        // Keyboard support
        brandItem.setAttribute('tabindex', '0');
        brandItem.setAttribute('role', 'button');
        brandItem.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            selectBrand(this.dataset.brand);
          }
        });
      });

      
      function selectBrand(brandId) {
        // Update brand active state
        brandItems.forEach(function (item) {
          item.classList.toggle('is-active', item.dataset.brand === brandId);
        });

        // Show correct model group
        modelGroups.forEach(function (group) {
          group.classList.toggle('is-active', group.dataset.brandModels === brandId);
        });

        // ── Clear ALL gen groups first ──────────────────────
        genGroups.forEach(function (group) {
          group.classList.remove('is-active');
        });

        // ── Clear model active states in ALL brand groups ───
        allModelItems.forEach(function (item) {
          item.classList.remove('is-active');
        });

        // Auto-select first model in this brand
        const activeModelGroup = sbcm.querySelector('[data-brand-models="' + brandId + '"]');
        if (activeModelGroup) {
          const firstModel = activeModelGroup.querySelector('[data-sbcm-model]');
          if (firstModel) {
            firstModel.classList.add('is-active');
            selectModel(firstModel.dataset.model, activeModelGroup);
          }
        }
      }

      // ── Model selection ──────────────────────────────────────────
      const allModelItems = sbcm.querySelectorAll('[data-sbcm-model]');
      const genGroups = sbcm.querySelectorAll('[data-model-gens]');

      allModelItems.forEach(function (modelItem) {
        modelItem.addEventListener('mouseenter', function () {
          const parentGroup = this.closest('[data-brand-models]');
          selectModel(this.dataset.model, parentGroup);
        });
        modelItem.addEventListener('click', function (e) {
          // If the model has generations, just switch panel (don't navigate)
          const modelId = this.dataset.model;
          const hasGens = sbcm.querySelector('[data-model-gens="' + modelId + '"]');
          if (hasGens && hasGens.querySelector('.sbcm__gen-list')) {
            e.preventDefault();
            const parentGroup = this.closest('[data-brand-models]');
            selectModel(modelId, parentGroup);
          }
          // Otherwise fall through to href navigation
        });
        modelItem.setAttribute('tabindex', '0');
        modelItem.setAttribute('role', 'button');
        modelItem.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const parentGroup = this.closest('[data-brand-models]');
            selectModel(this.dataset.model, parentGroup);
          }
        });
      });

      function selectModel(modelId, parentGroup) {
        // Update model active state within the parent brand group only
        if (parentGroup) {
          parentGroup.querySelectorAll('[data-sbcm-model]').forEach(function (item) {
            item.classList.toggle('is-active', item.dataset.model === modelId);
          });
        }

        // Show correct gen group
        genGroups.forEach(function (group) {
          group.classList.toggle('is-active', group.dataset.modelGens === modelId);
        });
      }

      // ── Init: ensure first brand/model/gen visible ───────────────
      const firstBrand = brandItems[0];
      if (firstBrand) {
        const firstBrandId = firstBrand.dataset.brand;
        const firstModelGroup = sbcm.querySelector('[data-brand-models="' + firstBrandId + '"]');
        if (firstModelGroup) {
          const firstModel = firstModelGroup.querySelector('[data-sbcm-model]');
          if (firstModel) {
            const firstModelId = firstModel.dataset.model;
            genGroups.forEach(function (group) {
              group.classList.toggle('is-active', group.dataset.modelGens === firstModelId);
            });
          }
        }
      }
      // Add inside initShopByCarMega(), after the model selection section:

      // ── Generation click (4th level toggle) ──────────────────────
      sbcm.querySelectorAll('.sbcm__gen-details').forEach(function(details) {
        var summary = details.querySelector('.sbcm__gen-summary');
        if (!summary) return;
        summary.addEventListener('click', function(e) {
          // On desktop, toggle the details open/close
          if (window.matchMedia('(min-width: 768px)').matches) {
            e.preventDefault();
            details.open = !details.open;
          }
          // On mobile, let native <details> behaviour handle it
        });
      });
    }

    // Re-init when mega nav opens (the theme uses <details> elements)
    function bindMegaNavOpen() {
      document.addEventListener('click', function (e) {
        const summary = e.target.closest('summary');
        if (!summary) return;
        // const details = summary.closest('details.js-mega-nav');
        const details = summary.closest('details.js-mega-nav, details.custom-mega-nav');
        if (!details) return;
        // Small delay so the DOM is visible before we init
        setTimeout(initShopByCarMega, 50);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initShopByCarMega();
        bindMegaNavOpen();
      });
    } else {
      initShopByCarMega();
      bindMegaNavOpen();
    }
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-merc"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
